import { connect } from 'react-redux';
import Component from './Component';

const mapStateToProps = (state) => ({
  estimate: state.screens.EstimateView.estimate,
})

const actionCreators = {};

export default connect(mapStateToProps, actionCreators)(Component);